

import File from '@/components/File/File.vue'

export default {
    auth: false,
    components: { File },
    async asyncData ({ route, error, redirect, $axios }) {
        let data
        let err
        await $axios
            .get(`/v1/files/${encodeURIComponent(route.params.hash)}`, {
                params: {
                    searchPage: route.query.searchPage,
                    searchOrder: route.query.searchOrder,
                    searchToken: route.query.searchToken,
                    onlyMeta: true
                }
            })
            .then((res) => {
                data = res.data
            })
            .catch((e) => {
                if (e.response?.status === 404) {
                    err = error({ statusCode: 404, message: e.response?.data?.displayMessage ?? 'لم يتم ايجاد الملف' })
                    return
                }
                if (e.response?.status === 403) {
                    err = error({ statusCode: 404, message: e.response?.data ?? 'ليس لديك صلاحية الوصول.' })
                    return
                }
                if (e.response?.status === 401) {
                    err = redirect('/Login')
                    return
                }

                err = error({ message: 'لقد حصل خطأ ما.' })
            })

        return err ?? { data }
    },
    data () {
        return {
            data: null
        }
    },
    head () {
        return this.$helpers.metaData({
            title: this.data?.meta?.name ?? 'عارض الملفات',
            description: this.data?.meta?.desc
        })
    }
}
